/* eslint-disable */
import React, { useRef, useEffect } from "react";
import themePropTypes from "../theme-prop-types";

const ProgressBar = ({
  value,
  progressLabel,
  progressStep,
  progressAriaLabel
}) => {
  const titleRef = useRef();

  useEffect(() => {
    titleRef.current.focus();
  }, []);

  return (
    <div
      className='progress-bar-container'
      ref={titleRef}
      tabIndex='-1'
      role='progressbar'
      aria-valuenow={value}
      aria-label={progressAriaLabel || value || "progressbar"}
    >
      {progressLabel && progressStep && (
        <div className='progress-title'>
          <div className='progress-label'>{progressLabel}</div>
          <div className='progress-step'>{progressStep}</div>
        </div>
      )}
      <div className='progress-bar-web-sdk'>
        <div
          className='progress-bar-filler-web-sdk'
          style={{ width: `${value}%` }}
        />
      </div>
    </div>
  );
};

ProgressBar.propTypes = themePropTypes.progressBar;

export default ProgressBar;
